// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-selector-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-out;
}

.wallet-selector-modal {
  background: linear-gradient(135deg, rgba(30, 30, 40, 0.98), rgba(20, 20, 30, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 40px;
  max-width: 480px;
  width: 90%;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  animation: slideUp 0.3s ease-out;
}

.wallet-selector-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 28px;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  padding: 0;
  line-height: 1;
}

.wallet-selector-close:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: scale(1.05);
}

.wallet-selector-title {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 10px 0;
  text-align: center;
}

.wallet-selector-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  margin: 0 0 40px 0;
}

.wallet-checking {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 20px;
}

.wallet-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #8b5cf6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.wallet-checking p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
}

.wallet-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 30px;
}

.wallet-option {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.04);
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  text-align: left;
}

.wallet-option:hover:not(.wallet-disabled) {
  background: rgba(255, 255, 255, 0.08);
  border-color: #8b5cf6;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.2);
}

.wallet-option.wallet-disabled {
  opacity: 0.5;
  cursor: pointer;
}

.wallet-option.wallet-disabled:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.2);
  transform: none;
}

.wallet-icon {
  font-size: 48px;
  line-height: 1;
  flex-shrink: 0;
}

.wallet-info {
  flex: 1 1;
}

.wallet-info h3 {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 4px 0;
}

.wallet-info p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

.wallet-badge {
  background: linear-gradient(135deg, #8b5cf6, #6d28d9);
  color: #fff;
  padding: 6px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.wallet-selector-footer {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 20px;
}

.wallet-help-text {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  margin: 0;
  line-height: 1.6;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Mobile Responsive */
@media (max-width: 600px) {
  .wallet-selector-modal {
    padding: 30px 20px;
    border-radius: 20px;
  }

  .wallet-selector-title {
    font-size: 26px;
  }

  .wallet-selector-subtitle {
    font-size: 14px;
    margin-bottom: 30px;
  }

  .wallet-option {
    padding: 16px 18px;
    gap: 16px;
  }

  .wallet-icon {
    font-size: 40px;
  }

  .wallet-info h3 {
    font-size: 18px;
  }

  .wallet-info p {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WalletSelector.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,mFAAmF;EACnF,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".wallet-selector-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.wallet-selector-modal {\n  background: linear-gradient(135deg, rgba(30, 30, 40, 0.98), rgba(20, 20, 30, 0.98));\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 24px;\n  padding: 40px;\n  max-width: 480px;\n  width: 90%;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  animation: slideUp 0.3s ease-out;\n}\n\n.wallet-selector-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #fff;\n  font-size: 28px;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  padding: 0;\n  line-height: 1;\n}\n\n.wallet-selector-close:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: scale(1.05);\n}\n\n.wallet-selector-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #fff;\n  margin: 0 0 10px 0;\n  text-align: center;\n}\n\n.wallet-selector-subtitle {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.6);\n  text-align: center;\n  margin: 0 0 40px 0;\n}\n\n.wallet-checking {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  gap: 20px;\n}\n\n.wallet-spinner {\n  width: 50px;\n  height: 50px;\n  border: 3px solid rgba(255, 255, 255, 0.1);\n  border-top-color: #8b5cf6;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.wallet-checking p {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 16px;\n}\n\n.wallet-options {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 30px;\n}\n\n.wallet-option {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 20px 24px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: 100%;\n  text-align: left;\n}\n\n.wallet-option:hover:not(.wallet-disabled) {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: #8b5cf6;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.2);\n}\n\n.wallet-option.wallet-disabled {\n  opacity: 0.5;\n  cursor: pointer;\n}\n\n.wallet-option.wallet-disabled:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: none;\n}\n\n.wallet-icon {\n  font-size: 48px;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.wallet-info {\n  flex: 1;\n}\n\n.wallet-info h3 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #fff;\n  margin: 0 0 4px 0;\n}\n\n.wallet-info p {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0;\n}\n\n.wallet-badge {\n  background: linear-gradient(135deg, #8b5cf6, #6d28d9);\n  color: #fff;\n  padding: 6px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.wallet-selector-footer {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding-top: 20px;\n}\n\n.wallet-help-text {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n  text-align: center;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 600px) {\n  .wallet-selector-modal {\n    padding: 30px 20px;\n    border-radius: 20px;\n  }\n\n  .wallet-selector-title {\n    font-size: 26px;\n  }\n\n  .wallet-selector-subtitle {\n    font-size: 14px;\n    margin-bottom: 30px;\n  }\n\n  .wallet-option {\n    padding: 16px 18px;\n    gap: 16px;\n  }\n\n  .wallet-icon {\n    font-size: 40px;\n  }\n\n  .wallet-info h3 {\n    font-size: 18px;\n  }\n\n  .wallet-info p {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
